import React, { useState } from "react";

const PasswordGate = ({ children }) => {
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);

  const correctPassword = "Djs2x102!pRoh?FOG"; 

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      localStorage.setItem("authenticated", "true");
      setAuthenticated(true);
    } else {
      alert("Incorrect password");
    }
  };

  if (authenticated || localStorage.getItem("authenticated") === "true") {
    return children;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#111",
        color: "#fff",
      }}
    >
      <h2>Enter Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={{
            padding: "10px",
            fontSize: "16px",
            marginRight: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
        <button
          type="submit"
          style={{
            padding: "10px 16px",
            fontSize: "16px",
            borderRadius: "4px",
            border: "none",
            backgroundColor: "#ffcc00",
            cursor: "pointer",
          }}
        >
          Unlock
        </button>
      </form>
    </div>
  );
};

export default PasswordGate;
